import React from "react"; 
import { PAGE_MODE } from "../../../../../constants/constants";
import BarButtonFw, { BUTTON_DEFAULT, } from "../../../../../framework/bar-button/BarButtonFw";
import FormFw from "../../../../../framework/form/FormFw";
import { UserUtil } from "../../../../../util/UserUtil";
import { useHistory } from "react-router-dom";
import { BasePage } from "../../../../../framework/pages/BasePage";
import { withRouter } from "react-router-dom";
 
class DatosSolicitantesSection extends BasePage {
    renderPage(pageApi) {
    // const history = useHistory()
    const getForm_DatosSolicitantes = () => pageApi.getComponent('form');
      
    const form_datosSolicitantes = {
      layout: 'vertical',
        load:{
        queryId: 815,
        search: true,
        hideMessage: true,
        hideMessageError: true,  
        params: { id_doc: pageApi.getParamId() }
        },
        // save: { 
        // queryId: 817,  
        // params: { est_tab : 2,id_SS : pageApi.getParamId(), id_user: UserUtil.getUserId() },
        // fnOk: (resp) => {  
        //     const id_doc = resp.dataObject?.id_doc;    
        //     const est_tab_actual = resp.dataObject?.est_tab;    

        //     if(est_tab_actual == 2){
        //       this.props.history.push(`/servicios-ejecutados/servicios-ejecutados/2/${id_doc}`)
        //     } 
        //     this.props.cambiarTabPanel("2",pageApi.getParamId()); 
        //   },
        // },
      title: '',
      //collapsible: true,
      fields:[
          {
              label: '  ', 
              fields: [
                { name: "titulo", label: "Nro. Solicitud", column: 1, readOnly: true },  
                {type: 'hidden', name: 'id_doc'},  
                { name: "raz_soc", label: "Empresa", column: 4, readOnly: true }, 
                { name: "solicitante", label: "Solicitante", column: 4, readOnly: true }, 
                { name: "servicio", label: "Tipo Servicio", column: 4, readOnly: true }, 
                { name: "nom_moneda", label: "Moneda", column: 4, readOnly: true },  
                { name: "nro_cotizacion", label: "Cotización", column: 4, readOnly: true },  
              ]   
          }
      ],
      onComponentLoad : (formApi, pageApi) =>{
          if (pageApi.getPageMode() !== PAGE_MODE.NEW)
              formApi.load();
      } 
    }
 
    const barButtonFooter_datos_solicitantes = {
        fields: [
            { 
              ...BUTTON_DEFAULT.RETURN,
              link: () => {
                const path = sessionStorage.getItem("ruta_retorno_ejecutar_servicio");
                sessionStorage.removeItem("ruta_retorno_ejecutar_servicio")
                return path;
              },
              alert: true,
              message: 'Está seguro de retornar?',
            },
            { ...BUTTON_DEFAULT.SAVE, label: "Continuar",onClick: () => { 
              // getForm_DatosSolicitantes().save() 
                this.props.cambiarTabPanel("2",pageApi.getParamId()); 
            } }, 
        ]
    }
  
    return (
      <>
        <FormFw
          name="form"
          getParentApi={pageApi.getApi}
          config={form_datosSolicitantes} 
        />
 
        <BarButtonFw 
          name="barFooter"
          getParentApi={pageApi.getApi}
          config={barButtonFooter_datos_solicitantes} 
        /> 
      </>
    ); 
  } 
} 

export default withRouter(DatosSolicitantesSection);